
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import SummaryDairyCard from './card/SummaryDairyCard.vue'
import { Observer } from 'mobx-vue'
import LazyImg from '@/components/lazyImg/index.vue'

@Observer
@Component({
  components: {
    NewSwiper,
    SummaryDairyCard,
    LazyImg
  }
})
export default class SummaryDairy extends Vue {
  animationClass: string = ''

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  @Emit('open-content')
  handleOpenContent(id: string) {
    return {
      momentId: id,
      type: 'dairy'
    }
  }

  // 触发lazy加载视区展示
  onSwiperChange() {
    if (!this.animationClass) {
      this.animationClass = 'lazy-trigger'
    }
  }
  onContentMousedown() {
    if (this.animationClass) {
      this.animationClass = ''
    }
  }

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  get PageStore() {
    return this.$store.$courseV2.Summary
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
